import { useEffect, useState } from 'react'

import { Box, Paper, Typography } from '@mui/material'

import { ApiKeysTable, ApiKeysTableRow } from 'modules/user/components/ApiKeysTable'
import useApiKeys from 'modules/user/hooks/useApiKeys'
import { AppPage } from 'pages/_app'

const ProjectOverviewPage: AppPage = () => {
  const { apiKeys, mutate } = useApiKeys()
  const [rows, setRows] = useState<Array<ApiKeysTableRow>>([])
  useEffect(() => {
    if (apiKeys) {
      const apiKeyRows = apiKeys.map((apiKey) => {
        return {
          id: apiKey.id,
          note: apiKey.note,
          createdAt: apiKey.createdAt,
          updatedAt: apiKey.updatedAt,
          isChecked: false,
        }
      })
      setRows(apiKeyRows)
    }
  }, [apiKeys])
  const updateRowCheckBox = function (id: string, checked: boolean) {
    const newRows = []
    for (const r of rows) {
      newRows.push(r)
      if (r.id === id) {
        r.isChecked = checked
      }
    }
    setRows(newRows)
  }

  const sortedRows = rows.sort((a, b) => {
    if (a.createdAt && b.createdAt) {
      return parseInt(b.createdAt) - parseInt(a.createdAt)
    } else {
      return 1
    }
  })
  return (
    <Box p={10}>
      <Paper elevation={3} sx={{ padding: '24px' }}>
        <Typography variant="h5" sx={{ marginBottom: '24px' }}>
          API Tokens
        </Typography>
        <ApiKeysTable rows={sortedRows || []} mutateFunction={mutate} updateRowFunction={updateRowCheckBox} />
      </Paper>
    </Box>
  )
}

export default ProjectOverviewPage
